import React from 'react'

export default function Mind() {
  return (
    <div className='container'>

       <div className='mind_main_component'>

       <iframe src="https://app.vectary.com/p/0sLgnu7B0GO4dYeWDXkhVT" frameborder="0" width="100%" height="100%"></iframe>

        </div>
    </div>
  )
}
